// tslint:disable: max-line-length

import React from "react";
import { MessageWithAvatarAndCTA } from "../../../../../core/atoms/atoms";
import { GoogleAnalyticsHelper } from "@travellocal/ui";
import * as WebRoutes from "@travellocal/utils/webRoutes";

interface UnconnectedMessage {
  enquiry: IEnquiry;
  country: ICountry;
}

export const UnconnectedMessage: React.FC<UnconnectedMessage> = (props) => {
  const { country, enquiry } = props;

  const avatar = country?.images?.find(
    image => image.locationImageType === LocationImageType.LtoMain
  ) ?? country?.defaultLto?.image;

  const messageWithAvatarProps = {
    avatarUrl: avatar?.thumbnailUrl,
    avatarName: `Your experts in ${country.name}`,
    ctaText: "Send us a message",
    ctaUrl: `${WebRoutes.customerEnquiryMessaging(enquiry.id)}#link-from-new-message-card`,
    ctaCallback: () => GoogleAnalyticsHelper.logEvent("Send message", "Click", "Low intent quote box"),
    subject: "Nearly there! Before we respond to your enquiry, please send us a message with any initial questions, thoughts or ideas you have."
  }

  return (
    <MessageWithAvatarAndCTA
      {...messageWithAvatarProps}
    >
      <>
        <p>
          We’ve received your enquiry and can see that you are still just researching your holiday.{` `}
          So, before we go any further, have a browse of the inspirational trip ideas and blog articles below.
        </p>
        <p>
          Once you’re ready to hear from us - or if you’re ready now! - simply send us a message{` `}
          with some thoughts or questions and we’ll continue planning your tailor-made trip.
        </p>
      </>
    </MessageWithAvatarAndCTA>
  );
}
